const defaultState = Object.freeze({
  left: {},
  right: {}
});
export {
  defaultState
};
//# sourceMappingURL=state.js.map
